export default __webpack_public_path__ + "static/char-s-54-zh-Hant-43710fb78916556fdaa71273875083ba.png";